import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_PETITION_DETAILS_STICKY_SIGN_CTA = defineFcm('petition_details_sticky_sign_cta')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				enabled: { type: 'boolean' },
			},
		}),
	)
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-platypus',
		scope: 'corgi-front-end',
		context: 'Petition Details Page Mobile Action Button',
		description:
			'Enables the sticky sign CTA experiment on the petition details page, which ships four arms. control and fake_control keep current behaviour: the inline sign CTA sits mid-screen and the sticky bottom bar docks only after the viewer scrolls past it. variant_1 docks the bar (sign + share) from page load, replacing the inline CTA. variant_2 docks a sign-only bar and leaves the share CTA inline in its original position. Turning this off returns every arm to current behaviour.\n\nhttps://change.atlassian.net/browse/CHANGE-97346',
		template: {
			enabled: true,
		},
	});
